import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import { Fragment } from "react";
import { Can } from "@/components/citadel/can";
import { AddArticleProductTypeModal } from "@/modals/stock/add-article-product-type-modal/add-article-product-type-modal";

export function ArticleProductTypesMenu() {
	/** Hooks */
	const { refetch } = useDataTableContext();
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Render */
	return (
		<Fragment>
			<Can
				action="create"
				subject="Stock"
			>
				<Button
					variant="primary"
					icon={<Icon name="Plus" />}
					onClick={disclosure.onOpen}
				>
					{t("stock.add_article_product_type")}
				</Button>
			</Can>
			{disclosure.isOpen && (
				<AddArticleProductTypeModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					onComplete={refetch}
				/>
			)}
		</Fragment>
	);
}
